import css from './HeroSection.module.css';

import { LandingPageSearchBar } from '../LandingPageSearchBar';
import { useState } from 'react';
import { Container, Heading, LinkBox, LinkOverlay, Text, Wrap } from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react';
import classnames from 'classnames';

const HeroSection = () => {
  const [selectedSector, setSelectedSector] = useState(null);

  const popularSearches = [
    {
      name: 'Yoga Studios',
      query: '/s?keywords=yoga',
    },
    {
      name: 'CrossFit Gyms',
      query: '/s?keywords=crossfit%20gym',
    },
    {
      name: 'Social',
      query: '/s?pub_vibesTag=has_any%3Asocial',
    },
    {
      name: 'Personal Trainers',
      query: '/s?pub_categoryLevel1=personal-trainer',
    },
    {
      name: 'Pilates Classes',
      query: '/s?pub_categoryLevel1=class&pub_classType=pilates',
    },
  ];

  return (
    <section className={classnames(css.heroWrapper, css.heroGradient)}>
      <Container maxW={'5xl'}>
        <Badge size="md" colorPalette="purple" variant="surface">
          Discover Your Next Workout
        </Badge>
        <Heading
          size={{
            base: '3xl',
            md: '5xl',
          }}
          fontWeight={'semibold'}
        >
          Find <span className={css.highlight}> Gyms</span>,
          <span className={css.highlight}> Classes</span>,
          <span className={css.highlight}> Sports Clubs</span>
          <br />&<span className={css.highlight}> Personal Trainers </span>
          Near You
        </Heading>
        <Text
          className={css.heroSubText}
          fontSize={{
            base: 'md',
            lg: 'lg',
          }}
          fontWeight="medium"
          color={'lightGreyText'}
        >
          Explore the best fitness facilities, sports clubs, and personal trainers in your area.
          <br />
          All in one place.
        </Text>
        <div className={css.heroCardWrapper}>
          <LandingPageSearchBar
            searchFields={{ categories: true, locationSearch: true }}
            setSelectedSector={setSelectedSector}
          />
        </div>
        <Wrap className={css.popularBadges}>
          <span>Popular:</span>
          {popularSearches.map(search => (
            <LinkBox
              key={search.name}
              className={`plausible-event-name=Landing+Page+Shortcut+Search+Button+${search.name.replace(
                ' ',
                '+'
              )}`}
            >
              <LinkOverlay href={search.query}>
                <Badge size="sm" colorPalette="purple" variant="outline">
                  {search.name}
                </Badge>
              </LinkOverlay>
            </LinkBox>
          ))}
        </Wrap>
      </Container>
    </section>
  );
};

export default HeroSection;
